import type * as FirebaseAuth from "firebase/auth"
import { useForm } from "react-hook-form"
import { api } from "../../core"
import { Button } from "react-bootstrap"

export const VirtualCastOAuthAccessTokenDeleteForm = (props: { firebase: FirebaseAuth.User }) => {
  const form = useForm({
    mode: "onBlur",
  })

  const onSubmit = async () => {
    try {
      const idToken = await props.firebase.getIdToken()
      const response = await api.DELETE("/api/v2/users/me/oauth/virtualcast/access-token", {
        headers: {
          authorization: `Bearer ${idToken}`,
        },
      })
      if (response.data === undefined) {
        console.error(`invalid response: ${JSON.stringify(response.error)}`)
        return
      }
    } catch (e) {
      console.error(e)
    }
  }

  const { isSubmitting, isValid } = form.formState

  return (
    <>
      <form className="d-flex w-100 flex-column gap-3" onSubmit={form.handleSubmit(onSubmit)}>
        <Button variant={"danger"} type="submit" className="form-control" disabled={isSubmitting || !isValid}>
          Delete Access Token
        </Button>
      </form>
    </>
  )
}
